import { useMutation } from '@tanstack/react-query';
import { toggleItemStatus } from 'api/services/item';
import { MutationParams } from './mutationTypes';

const useToggleItemMutation = (options?: MutationParams) => {
  return useMutation({
    mutationFn: (itemId: string) => toggleItemStatus(itemId),
    onSuccess: options?.onSuccess,
    onError: (error) => {
      console.error('Error toggling item status:', error);
    },
  });
};

export default useToggleItemMutation;
